import React from 'react';

const CharityCardSkeleton = ({ viewMode = 'grid' }) => {
  if (viewMode === 'list') {
    return (
      <div className="bg-card border border-border rounded-lg p-6 animate-pulse">
        <div className="flex items-start space-x-4">
          {/* Logo skeleton */}
          <div className="w-16 h-16 bg-muted rounded-lg flex-shrink-0" />
          
          {/* Content skeleton */}
          <div className="flex-1 space-y-3">
            <div className="flex items-start justify-between">
              <div className="space-y-2">
                <div className="h-5 bg-muted rounded w-48" />
                <div className="h-4 bg-muted rounded w-32" />
              </div>
              <div className="w-8 h-8 bg-muted rounded" />
            </div>
            
            <div className="space-y-2">
              <div className="h-4 bg-muted rounded w-full" />
              <div className="h-4 bg-muted rounded w-3/4" />
            </div>
            
            <div className="flex items-center justify-between">
              <div className="flex space-x-2">
                <div className="h-6 bg-muted rounded-full w-16" />
                <div className="h-6 bg-muted rounded-full w-12" />
              </div>
              <div className="flex items-center space-x-4">
                <div className="space-y-1">
                  <div className="h-3 bg-muted rounded w-16" />
                  <div className="h-4 bg-muted rounded w-20" />
                </div>
                <div className="h-8 bg-muted rounded w-20" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden animate-pulse">
      {/* Header image skeleton */}
      <div className="h-48 bg-muted" />
      
      {/* Content skeleton */}
      <div className="p-4 space-y-4">
        {/* Logo and title */}
        <div className="flex items-start space-x-3">
          <div className="w-12 h-12 bg-muted rounded-lg flex-shrink-0" />
          <div className="flex-1 space-y-2">
            <div className="h-5 bg-muted rounded w-3/4" />
            <div className="h-4 bg-muted rounded w-1/2" />
          </div>
        </div>
        
        {/* Mission skeleton */}
        <div className="space-y-2">
          <div className="h-4 bg-muted rounded w-full" />
          <div className="h-4 bg-muted rounded w-5/6" />
          <div className="h-4 bg-muted rounded w-2/3" />
        </div>
        
        {/* Trust badges skeleton */}
        <div className="flex space-x-2">
          <div className="h-6 bg-muted rounded-full w-16" />
          <div className="h-6 bg-muted rounded-full w-12" />
        </div>
        
        {/* Impact metrics skeleton */}
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <div className="h-3 bg-muted rounded w-16" />
            <div className="h-4 bg-muted rounded w-20" />
          </div>
          <div className="space-y-1">
            <div className="h-3 bg-muted rounded w-20" />
            <div className="h-4 bg-muted rounded w-16" />
          </div>
        </div>
        
        {/* Action buttons skeleton */}
        <div className="flex space-x-2">
          <div className="h-8 bg-muted rounded flex-1" />
          <div className="h-8 bg-muted rounded w-16" />
        </div>
      </div>
    </div>
  );
};

export default CharityCardSkeleton;